jQuery( function ($) {

  var OftenBoughtTogetherHandler = function() {
    this.attachItems();
    this.updateButtonData();
  }

  OftenBoughtTogetherHandler.prototype.attachItems = function() {
    let OftenBoughtTogetherHandler = this;
    let items = $("div.c-often-bought-together__item");
    items.each(function() {
      OftenBoughtTogetherHandler.checkboxHandler(this);
      OftenBoughtTogetherHandler.qtyHandler(this);
    });
  }

  OftenBoughtTogetherHandler.prototype.checkboxHandler = function(item) {
    $(item).find("input[type=checkbox]").on("change", { OftenBoughtTogetherHandler: this, OftenBoughtTogetherItem: item }, function(e) {
      if (this.checked) {
        console.log(e.data.OftenBoughtTogetherHandler.getItemProductId(e.data.OftenBoughtTogetherItem) + " checked");
      } else {
        console.log(e.data.OftenBoughtTogetherHandler.getItemProductId(e.data.OftenBoughtTogetherItem) + " unchecked");
      }
      e.data.OftenBoughtTogetherHandler.updateButtonData();
    });
  }

  OftenBoughtTogetherHandler.prototype.qtyHandler = function(item) {
    $(item).find("span.minus").on("click", { OftenBoughtTogetherHandler: this, OftenBoughtTogetherItem: item }, function(e) {
      e.data.OftenBoughtTogetherHandler.qtyMinus(e.data.OftenBoughtTogetherItem);
      e.data.OftenBoughtTogetherHandler.updateButtonData();
    });
    $(item).find("span.plus").on("click", { OftenBoughtTogetherHandler: this, OftenBoughtTogetherItem: item }, function(e) {
      e.data.OftenBoughtTogetherHandler.qtyPlus(e.data.OftenBoughtTogetherItem);
      e.data.OftenBoughtTogetherHandler.updateButtonData();
    });
    $(item).find("input[type=number].input-text.qty.text").on("keyup", { OftenBoughtTogetherHandler: this, OftenBoughtTogetherItem: item }, function(e) {
      e.data.OftenBoughtTogetherHandler.qtyKeyUp(e.data.OftenBoughtTogetherItem, $(this).val());
      e.data.OftenBoughtTogetherHandler.updateButtonData();
    });
    $(item).find("input[type=number].input-text.qty.text").on("change", { OftenBoughtTogetherHandler: this, OftenBoughtTogetherItem: item }, function(e) {
      e.data.OftenBoughtTogetherHandler.qtyChange(e.data.OftenBoughtTogetherItem);
      e.data.OftenBoughtTogetherHandler.updateButtonData();
    });
  }

  OftenBoughtTogetherHandler.prototype.qtyPlus = function(item) {
    let input = $(item).find('input[type=number].input-text.qty.text');
    let inputValue = parseInt(input.val());
    if (inputValue <= 1) {
      $(item).find("span.minus").addClass('active');
    }
    var count = parseInt(input.val()) + 1;
    input.val(count);
    input.change();
  }

  OftenBoughtTogetherHandler.prototype.qtyMinus = function(item) {
    let input = $(item).find('input[type=number].input-text.qty.text');
    let inputValue = parseInt(input.val());
    if (inputValue <= 2) {
      $(item).find("span.minus").removeClass('active');
    }

    var count = parseInt(input.val()) - 1;
    count = (count < 1 || isNaN(count)) ? 1 : count;
    input.val(count);
    input.change();
  }

  OftenBoughtTogetherHandler.prototype.qtyKeyUp = function(item, value) {
    let input = $(item).find('input[type=number].input-text.qty.text');
    let inputValue = value;

    var count = parseInt(inputValue);
    count = count < 1 ? 1 : count;
    input.val(count);
    input.change();
  }

  OftenBoughtTogetherHandler.prototype.qtyChange = function(item) {
    let input = $(item).find('input[type=number].input-text.qty.text');
    let inputValue = parseInt(input.val());
    if (inputValue < 1) {
      input.val(1);
      input.change();      
    }
  }

  OftenBoughtTogetherHandler.prototype.getItemProductId = function(item) {
    return $(item).find("input.input-text.qty.text").attr("data-product_id");
  }

  OftenBoughtTogetherHandler.prototype.getItemSKU = function(item) {
    return $(item).find("input.input-text.qty.text").attr("data-product_sku");
  }

  OftenBoughtTogetherHandler.prototype.getItemQuantity = function(item) {
    return parseInt($(item).find("input[type=number].input-text.qty.text").val());
  }

  OftenBoughtTogetherHandler.prototype.isItemChecked = function(item) {
    return $(item).find("input[type=checkbox]").is(":checked");
  }

  OftenBoughtTogetherHandler.prototype.updateButtonData = function() {
    let OftenBoughtTogetherHandler = this;
    let items = $("div.c-often-bought-together__item");
    let productData = [];
    items.each(function() {
      if (OftenBoughtTogetherHandler.isItemChecked(this)) {
        let item = this;
        productData.push({
          id: OftenBoughtTogetherHandler.getItemProductId(item),
          sku: OftenBoughtTogetherHandler.getItemSKU(item),
          qty: OftenBoughtTogetherHandler.getItemQuantity(item)
        });
      }
    });
    console.log(productData);
    let button = $("div.c-often-bought-together").find("a.c-button.add_to_cart_button");
    let productIds = [];
    let productQtys = [];
    let productSKUs = [];
    productData.forEach((product) => {
      productIds.push(product.id);
      productQtys.push(product.qty);
      productSKUs.push(product.sku);
    });
    button.attr('href', '?add-to-cart=' + productIds.toString());
    button.attr('data-product_id', productIds.toString());
    button.attr('data-product_sku', productSKUs.toString());
    button.attr('data-quantity', productQtys.toString());
  }

  new OftenBoughtTogetherHandler();
});
